import React from 'react';
import { useSelector } from 'react-redux';
import { Nav } from 'react-bootstrap';
import { MdAdminPanelSettings, MdManageAccounts, MdHome, MdInventory, MdPerson2, MdImportContacts, MdWarehouse, MdImportExport, MdMonetizationOn, MdSettings, MdList } from 'react-icons/md'; // Importing icons

const SideMenu = ({ mobile, isCollapsed }) => {
    const userRoles = useSelector((state) => state.user.roles);

    const isSuperAdmin = !!userRoles && userRoles.includes('ROLE_SUPERADMIN');

    // Define menu items with optional role restrictions
    const menuItems = [
        { section: 'General' },
        { icon: <MdHome />, label: 'Home', href: '/' },

        { section: 'SmartBill' },
        
        { icon: <MdMonetizationOn />, label: 'Import factura', href: '/smartbill/invoice', role: 'SMARTBILL' },
        { icon: <MdList />, label: 'Facturi importate', href: '/smartbill/invoices', role: 'SMARTBILL' },

        { icon: <MdInventory />, label: 'Stoc', href: '/smartbill/stock', role: 'SMARTBILL' },

        { section: 'SmartBill - stoc/depozite' },

        { icon: <MdImportExport />, label: 'Import stoc', href: '/smartbill/stock/import', role: 'SMARTBILL' },

        { icon: <MdWarehouse />, label: 'Depozite', href: '/smartbill/warehouse', role: 'SMARTBILL' },

        { section: 'SmartBill - clienti' },

        { icon: <MdPerson2 />, label: 'Clienti', href: '/smartbill/customers', role: 'SMARTBILL' },
        { icon: <MdImportContacts />, label: 'Clienti - import', href: '/smartbill/customers/import', role: 'SMARTBILL' },


        { section: 'Administration' },
        { icon: <MdAdminPanelSettings />, label: 'Tenants', href: '/admin/tenants', role: 'SUPERADMIN' },
        { icon: <MdManageAccounts />, label: 'Users', href: '/admin/users', role: 'ADMIN' },
        { icon: <MdSettings />, label: 'Properties', href: '/admin/properties', role: 'ADMIN' },

    ];

    // Filter menu items based on roles
    const filteredMenuItems = isSuperAdmin
        ? menuItems
        : menuItems.filter((item) => !item.role || userRoles.includes('ROLE_' + item.role));

    // Group filtered items by section
    const groupedMenuItems = filteredMenuItems.reduce((acc, item) => {
        if (item.section) {
            acc[item.section] = [];
        } else {
            const lastSection = Object.keys(acc).pop();
            acc[lastSection].push(item);
        }
        return acc;
    }, {});

    return (
        <>
            {Object.entries(groupedMenuItems).map(([section, items]) => (
                items.length > 0 && ( // Only show sections with at least one child
                    <div key={section} className="menu-section">
                        <div className="menu-section-title">{section}</div>
                        {items.map((item, index) => (
                            <Nav.Link
                                key={index}
                                href={item.href}
                                className="sidebar-link"
                            >
                                {mobile ? (
                                    <>
                                        <span className="me-2">{item.icon}</span>
                                        <span>{item.label}</span>
                                    </>
                                ) : (
                                    isCollapsed ? (
                                        <span>{item.icon}</span>
                                    ) : (
                                        <>
                                            <span className="me-2">{item.icon}</span>
                                            <span>{item.label}</span>
                                        </>
                                    )
                                )}
                            </Nav.Link>
                        ))}
                    </div>
                )
            ))}
        </>
    );
};

export default SideMenu;